import type { ReactNode } from "react";

/**
 * Why a button is off, as a tooltip on its wrapper: a disabled button takes no pointer events, so
 * a `title` on the button itself never shows. `describedBy` names an element on the page that
 * says the same in words, for readers who cannot hover.
 */
export function DisabledReason({
  reason,
  describedBy,
  children,
}: {
  reason: string | undefined;
  describedBy?: string;
  children: ReactNode;
}) {
  return (
    <span
      className="grid"
      title={reason}
      aria-describedby={reason !== undefined ? describedBy : undefined}
    >
      {children}
    </span>
  );
}
